import type {
  DashboardWidgetConfig,
  WidgetChartConfigCamelized,
  WidgetChartConfigCamelizedDefault,
} from 'src/types/dashboard';

const useWidgetChartConfig = (
  config: DashboardWidgetConfig,
  chartConfigDefault?: WidgetChartConfigCamelizedDefault,
): WidgetChartConfigCamelized => {
  const chartConfig: WidgetChartConfigCamelized = {
    backgroundColor: '',
    bubbleSize: 20,
    fontSize: null,
    fontWeight: '',
    listType: 'none',
    xAxisMax: null,
    yAxisMax: null,
    yAxisMin: null,
    yAxisStepSize: null,
    ...(chartConfigDefault ?? {}),
  };

  if (config.widget_chart_config) {
    const {
      background_color: backgroundColor,
      bubble_size: bubbleSize,
      font_size: fontSize,
      font_weight: fontWeight,
      list_type: listType,
      x_axis_max: xAxisMax,
      y_axis_max: yAxisMax,
      y_axis_min: yAxisMin,
      y_axis_step_size: yAxisStepSize,
    } = config.widget_chart_config;

    Object.assign(chartConfig, {
      backgroundColor,
      bubbleSize,
      fontSize,
      fontWeight,
      listType,
      xAxisMax,
      yAxisMax,
      yAxisMin,
      yAxisStepSize,
    });
  }

  return chartConfig;
};

export default useWidgetChartConfig;
